<template>
    <div class="flex flex-col justify-center pt-10 px-10">
          <LabelControl type="dynamic" class="text-grey-darkest font-bold text-6xl mb-8 uppercase text-center"
            :content="$t('msg007')" />
          <p class="text-grey-darkest text-4xl align-center justify-center text-center">
              {{$t('msg008')}}</p>
          <div class="flex flex-row justify-center align-center items-center">
            <ButtonControl text="Log Out" theme="error" @click="this.forceLogout()" />
          </div>
        </div>
</template>

<script>
import mixin from '@/mixins/controls.js';
import LabelControl from '@/components/controls/LabelControl.vue';
import ButtonControl from './ButtonControl.vue';
  
    export default {
        name: 'v-sessiontimeout',
        mixins: [mixin],
        components: {
            ButtonControl,
            LabelControl,
        },
    };
</script>

<style scoped></style>